
import RecoverUserid from "../views/public/RecoverUserid"
import ChangePassword from "../views/public/ChangePassword"
import RecoverPassword from "../views/public/RecoverPassword"
import Signup from "../views/public/Signup"
import Login from "../views/public/Login"
import Welcome from "../views/public/Welcome"
import Page404 from '../views/public/Page404'

import Main from '../views/private/Main'

import Landing from '../views/private/Landing2'
import Transactions from '../views/private/Transactions'
import Referrals from '../views/private/Referrals'
import Settings from '../views/private/Settings'
import Help from '../views/private/Help'
import Services from "../views/private/Services"
import Pool from '../views/private/Pool'
import Insights from "../views/private/Insights"
import { resolveLanguage } from "../lang/setup/i18n-setup"


export default [
    {
        path: '/',
        redirect: '/login',
        component: Welcome,
        children: [
            { path: '/signup', name: 'signup', component: Signup, redirect: '/login' },
            { path: '/login', name: 'login', component: Login },
            { path: '/recoveruserid', name: 'recoveruserid', component: RecoverUserid },
            { path: '/recoverpassword', name: 'recoverpassword', component: RecoverPassword },
            { path: '/changepassword=:pinhash', name: 'changepassword', component: ChangePassword, props: true },
            { path: '/activate=:activationHash', component: Login, props: true },
            { path: '/referralcode=:referCode', name: 'referralcode', component: Signup, props: true },
        ],
        // beforeEnter: (to, from, next) => {
        //     resolveLanguage().then(()=>{
        //         next()
        //     })
        // }
    },
    {
        path: '/',
        component: Main,
        redirect: '/home',
        children: [
            { path: '/home', name: 'home', component: Landing, },
            { path: '/transactions/:arg', name: 'transactions', component: Transactions, },
            { path: '/referrals', name: 'referrals', component: Referrals, },
            { path: '/settings', name: 'settings', component: Settings },
            { path: '/pool', name: 'pool', component: Pool },
            { path: '/services/:arg', name: 'services', component: Services},
            { path: '/help', name: 'help', component: Help },
            { path: '/insights', name: 'insights', component: Insights}
        ],
        // beforeEnter: (to, from, next) => {
        //     resolveLanguage().then(()=>{
        //         next()
        //     })
        // },
        meta: {
            requiresAuth: true // change to true in production
        },

    },
    {
        path: '*', component: Page404,
    },

]



// WEBPACK FOOTER //
// ./src/routes/index.js